import React, { useState, useRef, useEffect } from 'react';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';

import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useStoreContext } from '../../App/StoreProvider';
import './Inventory.scss';
import { Alert, Dropdown, OverlayTrigger, Table } from 'react-bootstrap';
import { GET_BOXES, GET_SET_UP, GET_INVENTORY_EXTRACT, GET_ALLOCATION_INVENTORY, GET_ACTIVE_QUEUE_BOXES, GET_JOB_PROFILE,GET_BELLY_DUMP_INVENTORY_EXTRACT } from '../../../graphql/client/queries';
import { useMutation, useQuery } from '@apollo/client/react';
import { useLazyQuery } from '@apollo/client/react';
import { CustomButton, Error, Loading } from '../../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    GetBoxes,
    GetBoxes_getBoxes_boxDetails as BoxDetails,
    getInventoryExtract,
    GetAllocationInventory_getAllocationInventory as AllocationInvDetails,
    GetAllocateLoadBoxes_getAllocateLoadBoxes as ActiveQueueDetails,
    GetAllocateLoadBoxes,
    GetActiveQueueBoxes,
    GetFullJobProfile,
    GetSetup,
    SpillBox,
} from '../../../types/schemaTypes';
// import {NumericFormat as NumberFormat} from 'react-number-format';
import { NumericFormat as NumberFormat } from 'react-number-format';
import {
    CONFIGURE_INVENTORY,
    DNU_OPERATE,
    EDIT_BOX,
    MOVE_BOXES,
    REVERT_BOXES,
    SPILL_BOX,
    UPDATE_BOX_IN_LOAD,
} from '../../../graphql/client/mutations';

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper'
import SetUpModal from './SetUpModal';
import { Link, useParams } from 'react-router-dom';
import { Routes } from '../../../utils';

import { Parser } from '@json2csv/plainjs';
import UnSavedConfirmationModal from './UnSavedConfirmationModal';
import { useReactToPrint } from 'react-to-print';
import { InventoryLayout } from './InventoryLayout';
import EditBoxesModal from './EditBoxesModal';
import AllocateLoadUI from './AllocateLoads/AllocateLoadUI';
import RevertBoxesModal from './RevertBoxesModal';
import SpillModal, { SpillRowData } from './SpillModal';

interface BoxesToMoveProps {
    boxId: number;
    boxDescrip: string;
    row: string;
    column: string;
    level: string;
    stageSheetProppantId: string;
    doNotUse: boolean;
    semiAllocated: boolean | null;
}
interface InventoryDataProps {
    rowName: string;
    b: BoxDetails[] | number;
    t: BoxDetails[] | number;
}

interface AllocateLoadProps {
    loadId: number;
}

const Inventory = ({ match }: any): React.ReactElement => {
    const dropIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'angle-down' }} />;

    const authContext = useAuthContext();
    const [{ auth }, dispatch] = useStoreContext();
    // const [state, dispatch] = useStoreContext();
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') + tabTitle;
    const abortController = new AbortController();

    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isAllocateAllLoads = authContext.userHasPermission(PermissionEnum.AllocateAllLoads);
    const isViewOnsiteInventory = authContext.userHasPermission(PermissionEnum.ViewOnsiteInventory);
    const isSetupLayout = authContext.userHasPermission(PermissionEnum.SetupLayout);
    const isPrintExport = authContext.userHasPermission(PermissionEnum.PrintExport);
    const isMoveBoxes = authContext.userHasPermission(PermissionEnum.MoveBoxes);
    const isEditOnsiteInventory = authContext.userHasPermission(PermissionEnum.EditOnsiteInventory);

    const [selectedTab, setSelectedTab] = useState<'proppant' | 'stage'>('proppant');

    const [inventoryData, setInventoryData] = useState<InventoryDataProps[]>();
    const [unassignedInventory, setUnassignedInventory] = useState<BoxDetails[]>([]);

    const [activeQueueBoxes, setActiveQueueBoxes] = useState<ActiveQueueDetails[]>();

    const [activeQueueBoxes1, setActiveQueueBoxes1] = useState<BoxDetails[]>();

    const [allocationInventory, setAllocationInventory] = useState<AllocationInvDetails[]>([]);
    const [outOfService, setOutOfService] = useState<BoxDetails[]>([]);

    const [movingItem, setMovingItem] = useState<BoxDetails>();
    const [boxesToMove, setBoxesToMove] = useState<BoxesToMoveProps[]>();

    const [dnuItems, setDnuItems] = useState<number[]>();
    const [dnuOperationType, setDnuOperationType] = useState<string>('');
    const [dnuUpdate, setDnuUpdate] = useState(false);

    const [dataUpdate, setDataUpdate] = useState(true);
    const [updateAllocationInventory, setUpdateAllocationInventory] = useState(false);
    const [resetAllocationInventory, setResetAllocationInventory] = useState(false);


    const [showSetUpModal, setShowSetUpModal] = useState(false);
    const [modalError, setModalError] = useState('');
    const [setUp, setSetUp] = useState(false);

    const [addColumn, setAddColumn] = useState(false);
    const [addRow, setAddRow] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);
    const [editAction, setEditAction] = useState<'Delete' | 'Add'>('Delete');

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [tabName, setTabName] = useState('');

    const [isPrinting, setIsPrinting] = useState(false);
    const [showAllocateModal, setShowAllocateModal] = useState(false);
    const [loadId, setLoadId] = useState<number | null>();
    const [boxDesc, setBoxDesc] = useState<string | null>();
    const [proppantDesc, setProppantDesc] = useState<string | null>();
    const [boxWeight, setBoxWeight] = useState<number | null>();
    const [proppantId, setProppantId] = useState<number | null>();
    const [showRevertModal, setShowRevertModal] = useState(false);
    const [showSpillModal, setShowSpillModal] = useState(false);
    

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        onBeforePrint: async () => setIsPrinting(true),
        onAfterPrint: async () => setIsPrinting(false),
    });
    const { jobId } = useParams()
    const jobIdVal: any = jobId

    const toasterOptions = { duration: 4500 };
    const Messages = {
        moveBox: 'Boxes moved successfully',
        remove: 'Boxes picked up successfully',
        spill: 'Boxes spilled successfully',
        setUp: 'Setup successful',
        addColumn: 'Added column successfully',
        addRow: 'Added row successfully',
        Add: 'Box updated successfully',
        Delete: 'Box deleted successfully',
        Revert: 'Box reverted successfully',
    };
    const ErrorMessages = {
        configure: 'Failed to configure inventory',
        moveBox: 'Failed to move boxes',
        remove: 'Failed to pick up boxes',
        spill: 'Failed to spill boxes',
        addColumn: 'Failed to add Column',
        addRow: 'Failed to add Row',
        Add: 'Failed to update Box',
        Delete: 'Failed to delete box',
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };

        const { data: jobProfileData } = useQuery<GetFullJobProfile>(GET_JOB_PROFILE, {
            variables: {
                jobId: parseInt(jobIdVal),
            },
            fetchPolicy: 'cache-and-network',
        });

    const { loading: getSetUpLoading, error: getSetupError, data: setupData } = useQuery<GetSetup>(GET_SET_UP, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
        pollInterval: 120000
    });
    let rowCount = 0;
    let columnCount = 0;
    if (setupData && setupData.getSetup) {
        rowCount = setupData.getSetup.rowCount ?? 0;
        columnCount = setupData.getSetup.columnCount ?? 0;
    }
    const columnNames: number[] = [];
    for (let i = 0; i < columnCount; i++) {
        columnNames.push(i + 1);
    }

    useEffect(() => {
        if (setupData && setupData.getSetup && setupData.getSetup.rowCount === 0 && setupData.getSetup.columnCount === 0) {
            configureInventory({
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        rowCount: 5,
                        columnCount: 5,
                    },
                },
            });
        }
    }, [setupData]);


    const { loading: getBoxesLoading, error: getBoxesError, data: boxesData } = useQuery<GetBoxes>(GET_BOXES, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
        pollInterval: 120000,
    });

    const { loading: getAllocationInvLoading, error: getAllocationInvError, data: allocationInventoryData, refetch } = useQuery<{ getAllocationInventory: (AllocationInvDetails | null)[] | null }>(GET_ALLOCATION_INVENTORY, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (allocationInventoryData?.getAllocationInventory && allocationInventoryData.getAllocationInventory.length !== 0 && !resetAllocationInventory) {
            setAllocationInventory((allocationInventoryData.getAllocationInventory ?? []).filter((a): a is AllocationInvDetails => a != null));
            setUpdateAllocationInventory(true);
        }
    }, [allocationInventoryData, resetAllocationInventory]);

    useEffect(() => {
        if (allocationInventoryData && allocationInventoryData.getAllocationInventory) {
            const tempallocationInventory: AllocationInvDetails[] = [];
            
            if (resetAllocationInventory) {
                setAllocationInventory([]); // Clear inventory if resetInventory is true
            }
            
            if (allocationInventoryData.getAllocationInventory.length > 0) {
                allocationInventoryData.getAllocationInventory.forEach(allocationInventory => {
                    if (allocationInventory && updateAllocationInventory) {
                        tempallocationInventory.push(allocationInventory);
                    }
                });
                
                if (tempallocationInventory.length > 0 || updateAllocationInventory) {
                    setAllocationInventory(tempallocationInventory); // Only update state if there are new items
                }
            }
            
            // Reset flags after processing
            if (updateAllocationInventory) setUpdateAllocationInventory(false);
            if (resetAllocationInventory) setResetAllocationInventory(false);
        }
    }, [allocationInventoryData, updateAllocationInventory, resetAllocationInventory]);
    

    const { loading: getActiveQueueLoading, error: getActiveQueueInvError, data: activeQueueData} = useQuery<GetActiveQueueBoxes>(GET_ACTIVE_QUEUE_BOXES, {
            variables: {
                jobId: parseInt(jobIdVal),
            },
            fetchPolicy: 'network-only',
        });

    useEffect(() => {
        if (activeQueueData?.getActiveQueueBoxes && activeQueueData.getActiveQueueBoxes.length !== 0) {
            setActiveQueueBoxes((activeQueueData.getActiveQueueBoxes ?? []).filter((b): b is ActiveQueueDetails => b != null));
        }
    }, [activeQueueData]);


    // const { loading: getInventoryBoxLoading, error: getInventoryBoxError, data: inventoryBoxData } = useQuery(
    //     GET_INVENTORY_EXTRACT,
    //     {
    //         variables: {
    //             jobId: parseInt(match.params.jobId),
    //         },
    //         fetchPolicy: 'network-only',
    //     },
    // );

    const [
        getJobId,
        { loading: getInventoryBoxLoading, error: getInventoryBoxError, data: inventoryBoxData },
    ] = useLazyQuery<getInventoryExtract>(GET_INVENTORY_EXTRACT, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (
            !getInventoryBoxLoading &&
            inventoryBoxData?.getInventoryExtract?.boxDetails &&
            inventoryBoxData.getInventoryExtract.boxDetails.length !== 0
        ) {
            const boxList = inventoryBoxData.getInventoryExtract.boxDetails.map(box => {
                if (!box) return {};
                return {
                    Box: box.boxDesc,
                    'Net Weight': box.weightDelivered ?? '',
                    'Proppant Type': box.proppantDesc ?? '',
                    'Current Box Location': box.padLocation ?? '',
                    'Sand PO': (box.sandPO ?? '') + '\t',
                    'Sand Ticket': (box.sandTicket ?? '') + '\t',
                    'Load Number': (box.loadId ?? '') + '\t',
                    'Box Status': box.boxStatus ?? '',
                    'Associated to Stage': box.associatedtoStage ?? '',
                    'Driver Name': box.driverName ?? '',
                    'Truck Number': box.truckNumber ?? '',
                    'Chassis Number': box.chassisNumber ?? '',
                    'Carrier Name': box.companyName ?? '',
                    'Gross Weight': box.grossWeight ?? '',
                    'Tare Weight': box.tareWeight ?? '',
                    'Loading Facility': box.lofa ?? '',
                    'Weight Remaining': box.weightRemaining ?? '',
                };
            });

            const opts = {};
            const parser = new Parser(opts);
            const csvData = parser.parse(boxList.filter((o) => o && Object.keys(o).length > 0));
            const file = new Blob([csvData], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Inventory.csv`;
            a.click();
        }
    }, [getInventoryBoxLoading, inventoryBoxData]);

    // Belly Dump Inventory
    type BellyDumpExtract = { getBellyDumpInventoryExtract?: { boxDetails?: Array<{ boxDesc?: string | null; weightDelivered?: unknown; proppantDesc?: string | null; padLocation?: string | null; sandPO?: string | null; sandTicket?: string | null; loadId?: unknown; boxStatus?: string | null; associatedtoStage?: string | null; driverName?: string | null; truckNumber?: string | null; chassisNumber?: string | null; companyName?: string | null; grossWeight?: unknown; tareWeight?: unknown; lofa?: string | null; weightRemaining?: unknown; bellyDumpDetails?: string | null } | null> | null } | null };
    const [
        getBellyDumpJobId,
        { loading: getInventoryBellyBoxLoading, error: getInventoryBellyBoxError, data: inventoryBellyBoxData },
    ] = useLazyQuery<BellyDumpExtract>(GET_BELLY_DUMP_INVENTORY_EXTRACT, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (
            !getInventoryBellyBoxLoading &&
            inventoryBellyBoxData?.getBellyDumpInventoryExtract?.boxDetails &&
            inventoryBellyBoxData.getBellyDumpInventoryExtract.boxDetails.length !== 0
        ) {
            const boxList = inventoryBellyBoxData.getBellyDumpInventoryExtract.boxDetails.map((box: { boxDesc?: string | null; weightDelivered?: unknown; proppantDesc?: string | null; padLocation?: string | null; sandPO?: string | null; sandTicket?: string | null; loadId?: unknown; boxStatus?: string | null; associatedtoStage?: string | null; driverName?: string | null; truckNumber?: string | null; chassisNumber?: string | null; companyName?: string | null; grossWeight?: unknown; tareWeight?: unknown; lofa?: string | null; weightRemaining?: unknown; bellyDumpDetails?: string | null } | null) => {
                if (!box) return {};
                const bellyDumpDetails = (box.bellyDumpDetails ?? '').split('|').map((detail: string, index: number) => {
                    const parts = detail.split(',').map(item => item.split(':')[1]);
                    return {
                        [`LoadId_${index + 1}`]: parts[0],
                        [`SandTicket_${index + 1}`]: parts[1],
                        [`SandTicketWeight_${index + 1}`]: parts[2],
                        [`SandTicketWeightRemaining_${index + 1}`]: parts[3],
                    };
                }).reduce((acc: Record<string, unknown>, curr: Record<string, unknown>) => ({ ...acc, ...curr }), {});
                return {
                    Box: box.boxDesc,
                    'Net Weight': box.weightDelivered ?? '',
                    'Proppant Type': box.proppantDesc ?? '',
                    'Current Box Location': box.padLocation ?? '',
                    'Sand PO': (box.sandPO ?? '') + '\t',
                    'Sand Ticket': (box.sandTicket ?? '') + '\t',
                    'Load Number': String(box.loadId ?? '') + '\t',
                    'Box Status': box.boxStatus ?? '',
                    'Associated to Stage': box.associatedtoStage ?? '',
                    'Driver Name': box.driverName ?? '',
                    'Truck Number': box.truckNumber ?? '',
                    'Chassis Number': box.chassisNumber ?? '',
                    'Carrier Name': box.companyName ?? '',
                    'Gross Weight': box.grossWeight ?? '',
                    'Tare Weight': box.tareWeight ?? '',
                    'Loading Facility': box.lofa ?? '',
                    'Weight Remaining': box.weightRemaining ?? '',
                    ...bellyDumpDetails,
                };
            });

            const opts = {};
            const parser = new Parser(opts);
            const csvData = parser.parse(boxList.filter((o) => o && Object.keys(o).length > 0));
            const file = new Blob([csvData], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Inventory.csv`;
            a.click();
        }
    }, [getInventoryBellyBoxLoading, inventoryBellyBoxData]);

    useEffect(() => {
        if (dnuOperationType === 'inservice' || dnuOperationType === 'remove' || dnuOperationType === 'spill') {
            setDnuUpdate(true);
            setResetAllocationInventory(true);
        } else {
            setDataUpdate(true);
            setUpdateAllocationInventory(true);
        }
    }, [boxesData, setupData]);

    // useEffect(() => {
    //     console.log('allocationInventoryData:-----', allocationInventoryData);
    // }, [allocationInventoryData]);
    

    const handleOnCompleteMutation = (mutationType: string) => {

        toast.success(Messages[mutationType], toastOpt);
        if (mutationType === 'inservice' || mutationType === 'remove' || mutationType === 'spill') {
            setDnuItems(undefined);
            setShowSpillModal(false);
            return;
        }
        setBoxesToMove(undefined);
        setMovingItem(undefined);
    };

    const handleOnError = (mutationType: string, errorMessage: string) => {
        const message = `${ErrorMessages[mutationType] ?? 'Operation failed'} ${errorMessage}`;
        toast.error(message, toastOpt);
        if (mutationType === 'spill') {
            setModalError(errorMessage.trim());
        }
        if (mutationType === 'setUp') {
            setSetUp(false);
        }
        if (mutationType === 'addColumn') {
            setAddColumn(false);
        }
        if (mutationType === 'addRow') {
            setAddRow(false);
        }
    };

    const [revertBoxes, { loading: revertMutationLoading }] = useMutation(REVERT_BOXES, {
        onCompleted: () => {
            toast.success(Messages["Delete"], toastOpt);
            setShowRevertModal(false);
        },
        onError: error => setModalError(error.message.replace('GraphQL error:', '')),
        refetchQueries: () => {
            return [
                {
                    query: GET_ALLOCATION_INVENTORY,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_SET_UP,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
                {
                    query: GET_BOXES,
                    variables: {
                        jobId: parseInt(jobIdVal),
                    },
                },
            ]
        }
        //onError: error => handleOnError('moveBox', error.message.replace('GraphQL error:', '')),
    });

    const [moveBoxes, { loading: mutationLoading }] = useMutation(MOVE_BOXES, {
        onCompleted: () => handleOnCompleteMutation('moveBox'),
        refetchQueries: [
            {
                query: GET_SET_UP,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_BOXES,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
        ],
        onError: error => handleOnError('moveBox', error.message.replace('GraphQL error:', '')),
    });

    const [dnuoperate, { loading: dnuMutationLoading }] = useMutation(DNU_OPERATE, {
        onCompleted: () => handleOnCompleteMutation(dnuOperationType),
        refetchQueries: [
            {
                query: GET_SET_UP,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_BOXES,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
        ],
        onError: error => handleOnError(dnuOperationType, error.message.replace('GraphQL error:', '')),
    });

    const [spillBox, { loading: spillMutationLoading }] = useMutation<SpillBox>(SPILL_BOX, {
        onCompleted: data => {
            const errors = data?.spillBox?.errors?.filter((error): error is string => Boolean(error));
            if (errors && errors.length > 0) {
                handleOnError('spill', errors.join(' '));
                return;
            }
            handleOnCompleteMutation('spill');
        },
        refetchQueries: [
            {
                query: GET_SET_UP,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_BOXES,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
        ],
        onError: error => handleOnError('spill', error.message.replace('GraphQL error:', '')),
    });

    const [editBoxes, { loading: editLoading }] = useMutation(EDIT_BOX, {
        onCompleted: () => {
            toast.success(Messages[editAction], toastOpt);

            setShowEditModal(false);
        },
        refetchQueries: [
            {
                query: GET_ALLOCATION_INVENTORY,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_SET_UP,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_BOXES,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
        ],
        onError: error => setModalError(error.message.replace('GraphQL error:', '')),
    });

    const [updateBoxInLoad, { loading: updateLoading }] = useMutation(UPDATE_BOX_IN_LOAD, {
        onError: error => {
            toast.error(error.message, toastOpt);

        },
    });

    const handleOnCompleteConfiguration = configType => {
        toast.success(Messages[configType], toastOpt);

        if (configType === 'setUp') {
            setShowSetUpModal(false);
            setSetUp(false);
        }
        if (configType === 'addColumn') {
            setAddColumn(false);
        }
        if (configType === 'addRow') {
            setAddRow(false);
        }
    };

    const handleOnClickRevert = () => {
       setShowRevertModal(true);
    };

    const [configureInventory, { loading: configureMutationLoading }] = useMutation(CONFIGURE_INVENTORY, {
        onCompleted: () => {
            if (setUp) handleOnCompleteConfiguration('setUp');
            if (addColumn) handleOnCompleteConfiguration('addColumn');
            if (addRow) handleOnCompleteConfiguration('addRow');
        },
        refetchQueries: [
            {
                query: GET_SET_UP,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
            {
                query: GET_BOXES,
                variables: {
                    jobId: parseInt(jobIdVal),
                },
            },
        ],
        onError: error => {
            const errorMessage = error.message.replace('GraphQL error:', '');
            if (setUp) setModalError(errorMessage);
            else if (addColumn) handleOnError('addColumn', errorMessage);
            else if (addRow) handleOnError('addRow', errorMessage);
            else handleOnError('configure', errorMessage);
            setSetUp(false);
        },
    });

    const proppantLegends: { title: string; color: string }[] = [];
    if (boxesData && boxesData.getBoxes && boxesData.getBoxes.proppantColors) {
        boxesData.getBoxes.proppantColors.forEach(proppantColorItem => {
            if (proppantColorItem) {
                proppantLegends.push({
                    title: proppantColorItem.descrip ?? '',
                    color: proppantColorItem.color ?? '',
                });
            }
        });
    }

    const stageLegends: { title: string; color: string }[] = [];
    if (boxesData && boxesData.getBoxes && boxesData.getBoxes.stageSheetColors) {
        boxesData.getBoxes.stageSheetColors.forEach(stageSheetColorItem => {
            if (stageSheetColorItem) {
                stageLegends.push({
                    title: stageSheetColorItem.descrip ?? '',
                    color: stageSheetColorItem.color ?? '',
                });
            }
        });
    }

    const emptyBoxes: string[] = [];
    let emptyCount = 0;
    let OOSCount = 0;
    let unassignedCount = 0;
    const assginedCount: { name: string; weight: string; count: number }[] = [];

    let jobName = '';
    if (boxesData && boxesData.getBoxes && boxesData.getBoxes.boxDetails) {
        const tempInventoryData: InventoryDataProps[] = [];
        const tempUnassignedInventory: BoxDetails[] = [];
        const tempActiveQueue: BoxDetails[] = [];
        const tempOutOfService: BoxDetails[] = [];

        jobName = boxesData.getBoxes.wellName ?? '';

        if (dataUpdate) {
            setInventoryData(undefined);
            setOutOfService([]);
            setUnassignedInventory([]);
        }

        if (dnuUpdate && dnuOperationType === 'inservice') {
            setOutOfService([]);
            setUnassignedInventory([]);
        }

        if (dnuUpdate && (dnuOperationType === 'remove' || dnuOperationType === 'spill')) {
            setOutOfService([]);
        }

        if (rowCount > 0) {
            let rowName = 'A';
            for (let i = 0; i < rowCount; i++) {
                tempInventoryData.push({
                    rowName: rowName,
                    b: new Array(columnCount).fill(-1),
                    t: new Array(columnCount).fill(-1),
                });
                rowName = String.fromCharCode(rowName.charCodeAt(0) + 1);
            }
        }


        if (boxesData.getBoxes.boxDetails.length > 0) {
            boxesData.getBoxes.boxDetails.map(boxDetail => {
                if (
                    boxDetail &&
                    boxDetail.queueDesc === 'Assigned' &&
                    (dataUpdate || (!inventoryData && dataUpdate)) &&
                    rowCount > 0 &&
                    columnCount > 0
                ) {
                    const rowId = boxDetail.rowId ?? 0;
                    const columnId = boxDetail.columnId ?? 0;
                    const index = rowId - 1;
                    // alert(index)

                    tempInventoryData[index].rowName = boxDetail.row ?? '';
                    if (boxDetail.level === 'Top') {
                        tempInventoryData[index].t[columnId - 1] = boxDetail;
                    }
                    if (boxDetail.level === 'Bottom') {
                        tempInventoryData[index].b[columnId - 1] = boxDetail;
                    }
                    setInventoryData(tempInventoryData);
                }

                if (
                    boxDetail &&
                    boxDetail.queueDesc === 'UnAssigned' &&
                    (dataUpdate ||
                        (unassignedInventory.length === 0 && dataUpdate) ||
                        (dnuUpdate && (dnuOperationType === 'inservice' || dnuOperationType === 'remove' || dnuOperationType === 'spill')))
                ) {
                    tempUnassignedInventory.push(boxDetail);
                    setUnassignedInventory(tempUnassignedInventory);
                }

                if (
                    boxDetail &&
                    boxDetail.queueDesc === 'Active' &&
                    (dataUpdate ||
                        (unassignedInventory.length === 0 && dataUpdate) ||
                        (dnuUpdate && (dnuOperationType === 'inservice' || dnuOperationType === 'remove' || dnuOperationType === 'spill')))
                ) {
                    tempActiveQueue.push(boxDetail);
                    setActiveQueueBoxes1(tempActiveQueue);
                }

                if (
                    boxDetail &&
                    boxDetail.queueDesc === 'DoNotUse' &&
                    boxDetail.boxDesc &&
                    (dataUpdate || (outOfService.length === 0 && dataUpdate) || dnuUpdate)
                ) {
                    tempOutOfService.push(boxDetail);
                    setOutOfService(tempOutOfService);
                }

                if (boxDetail && boxDetail.queueDesc === 'Empty' && boxDetail.boxDesc) {
                    emptyBoxes.push(boxDetail.boxDesc);
                }

                dataUpdate && setDataUpdate(false);
                dnuUpdate && setDnuUpdate(false);
            });
        }

        if (boxesData.getBoxes.boxStats) {
            boxesData.getBoxes.boxStats.forEach(boxStat => {
                if (!boxStat) return;
                if (boxStat.queueDescrip === 'Empty') emptyCount = boxStat.boxCount ?? 0;
                if (boxStat.queueDescrip === 'DoNotUse') OOSCount = boxStat.boxCount ?? 0;
                if (boxStat.queueDescrip === 'UnAssigned') unassignedCount = boxStat.boxCount ?? 0;
                if (boxStat.queueDescrip === 'Assigned')
                    assginedCount.push({
                        name: boxStat.proppantDescrip ?? '',
                        weight: boxStat.weight ?? '',
                        count: boxStat.boxCount ?? 0,
                    });
            });
        }

        if (!inventoryData) {
            dataUpdate && setDataUpdate(false);
            setInventoryData(tempInventoryData);
        }
    }

    const handleOnDragOver = ev => {
        ev.preventDefault();
    };

    const handleOnDragItem = (ev, boxDetail) => {
        if (!isMoveBoxes) return;

        setMovingItem(boxDetail);

        ev.dataTransfer.setData('text', ev.target.id);
    };

    const downloadFileHandler = () => {
        if (jobProfileData?.getJobProfile?.jobDetails?.isBellyDump) {
            getBellyDumpJobId({
                variables: {
                    jobId: parseInt(jobIdVal),
                    key: (Math.random() + 1).toString(36).substring(7),
                },
            });
        } else {
            getJobId({
                variables: {
                    jobId: parseInt(jobIdVal),
                    key: (Math.random() + 1).toString(36).substring(7),
                },
            });
        }
    };

    const handleOnEdit = (boxIds, loadId, jobSummaryId, weight, action, sandTicket, boxNumber) => {
        setEditAction(action);
        editBoxes({
            variables: {
                input: {
                    boxIds: boxIds,
                    loadId: loadId,
                    jobSummaryId: jobSummaryId,
                    weight: weight,
                    action: action,
                },
            },
        });
        if (action === 'Add') {
            updateBoxInLoad({
                variables: {
                    input: {
                        loadId: loadId,
                        boxId: parseInt(boxIds),
                        boxNumber: boxNumber,
                    },
                },
            });
        }
    };

    const handleOnRevert = (selectedBoxes) => {
        revertBoxes({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    boxDetails: selectedBoxes,
                },
            },
        });
    };

    const handleOnDropAssigned = (ev, index, row, column, columnId, level) => {
        if (!isMoveBoxes) return;

        ev.preventDefault();
        const tempInventoryData = inventoryData ?? [];

        if (!movingItem || movingItem.queueDesc == 'Active') return;

        if (movingItem.rowId === 0 && movingItem.columnId === 0) {
            const movingItemMirror = { ...movingItem }
            movingItemMirror.column = column.toString();
            movingItemMirror.columnId = columnId + 1;
            movingItemMirror.row = row;
            movingItemMirror.rowId = index + 1;
            movingItemMirror.level = level;

            // setMovingItem(movingItemMirror);
            //  movingItem ={...movingItemMirror}

            if (level === 'Bottom') {
                tempInventoryData[index].b[column - 1] = movingItemMirror;
            }
            if (level === 'Top') {
                tempInventoryData[index].t[column - 1] = movingItemMirror;
            }
            setInventoryData(tempInventoryData);

            const tempUnassignedInventory = unassignedInventory;
            let movingItemIndex = -1;
            tempUnassignedInventory.map((item, index) => {
                if (item.boxId === movingItemMirror.boxId) movingItemIndex = index;
            });
            tempUnassignedInventory.splice(movingItemIndex, 1);
            setUnassignedInventory(tempUnassignedInventory);
        } else if (movingItem.rowId && movingItem.columnId) {

            const movingItemRow = movingItem.rowId - 1;
            let movingItemLevel = 'b';
            if (movingItem.level === 'Top') movingItemLevel = 't';
            const movingItemColumn = movingItem.columnId - 1;
            const movingItemMirror = { ...movingItem }
            movingItemMirror.column = column.toString();
            movingItemMirror.columnId = columnId + 1;
            movingItemMirror.row = row;
            movingItemMirror.rowId = index + 1;
            movingItemMirror.level = level;

            if (level === 'Bottom') {
                tempInventoryData[index].b[column - 1] = movingItemMirror;
            }
            if (level === 'Top') {
                tempInventoryData[index].t[column - 1] = movingItemMirror;
            }
            tempInventoryData[movingItemRow][movingItemLevel][movingItemColumn] = -1;
            setInventoryData(tempInventoryData);
        }

        const tempBoxesToMove = boxesToMove;
        let exists = false;
        tempBoxesToMove?.map(boxToMove => {
            if (boxToMove.boxId === movingItem.boxId) {
                exists = true;
                boxToMove.boxId = movingItem.boxId;
                boxToMove.boxDescrip = movingItem.boxDesc ?? '';
                boxToMove.column = column.toString();
                boxToMove.row = row;
                boxToMove.level = level;
                boxToMove.stageSheetProppantId = movingItem.stageSheetProppantId ?? '';
                boxToMove.doNotUse = false;
            }
        });

        if (!exists) {
            const tempBoxToMove: BoxesToMoveProps = {
                boxId: movingItem.boxId ?? 0,
                boxDescrip: movingItem.boxDesc ?? '',
                column: column.toString(),
                row: row,
                level: level,
                stageSheetProppantId: movingItem.stageSheetProppantId ?? '',
                doNotUse: false,
                semiAllocated: movingItem.semiAllocated,
            };
            if (!tempBoxesToMove) setBoxesToMove([tempBoxToMove]);
            else {
                tempBoxesToMove?.push(tempBoxToMove);
                setBoxesToMove(tempBoxesToMove);
            }
        }

        setMovingItem(undefined);
    };

    const handleOnDropUnassigned = ev => {
        if (!isMoveBoxes) return;

        ev.preventDefault();
        // const tempInventoryData:number | InventoryDataProps[] | undefined = inventoryData;
        const tempInventoryData = inventoryData

        if (!movingItem || (movingItem.rowId === 0 && movingItem.columnId === 0)) return;

        const level = movingItem.level === 'Top' ? 't' : 'b';
        if (tempInventoryData && movingItem.rowId && level && movingItem.columnId) {
            tempInventoryData[movingItem.rowId - 1][level][movingItem.columnId - 1] = -1;
        }
        setInventoryData(tempInventoryData);


        const tempBoxesToMove = boxesToMove;

        let exists = false;
        tempBoxesToMove?.map(boxToMove => {
            if (boxToMove.boxId === movingItem.boxId) {

                exists = true;
                boxToMove.boxId = movingItem.boxId;
                boxToMove.boxDescrip = movingItem.boxDesc ?? '';
                boxToMove.column = '';
                boxToMove.row = '';
                boxToMove.level = '';
                boxToMove.stageSheetProppantId = movingItem.stageSheetProppantId ?? '';
                boxToMove.doNotUse = false;
            }
        });

        if (!exists) {

            const tempBoxToMove: BoxesToMoveProps = {
                boxId: movingItem.boxId ?? 0,
                boxDescrip: movingItem.boxDesc ?? '',
                column: '',
                row: '',
                level: '',
                stageSheetProppantId: movingItem.stageSheetProppantId ?? '',
                doNotUse: false,
                semiAllocated: movingItem.semiAllocated,
            };
            if (!tempBoxesToMove) {
                setBoxesToMove([tempBoxToMove]);

            }
            else {
                tempBoxesToMove?.push(tempBoxToMove);
                setBoxesToMove(tempBoxesToMove);

            }
        }

        const tempUnassignedInventory = unassignedInventory;
        const movingItemMirror = { ...movingItem }

        movingItemMirror.column = '';
        movingItemMirror.columnId = 0;
        movingItemMirror.row = '';
        movingItemMirror.rowId = 0;
        movingItemMirror.level = '';
        //  movingItem ={...}
        setMovingItem(movingItemMirror)
        tempUnassignedInventory.push(movingItemMirror);
        setUnassignedInventory(tempUnassignedInventory);

        setMovingItem(undefined);
    };

    const handleOnDropOutOfService = ev => {
        if (!isMoveBoxes) return;

        ev.preventDefault();
        if (!movingItem) return;

        if (movingItem.queueDesc === 'Active') return;

        const movingItemMirror = { ...movingItem }
        if (movingItem.rowId === 0 && movingItem.columnId === 0) {
            const tempUnassignedInventory = unassignedInventory;
            let movingItemIndex = -1;
            tempUnassignedInventory.map((item, index) => {
                if (item.boxId === movingItem.boxId) movingItemIndex = index;
            });
            tempUnassignedInventory.splice(movingItemIndex, 1);
            setUnassignedInventory(tempUnassignedInventory);
        } else if (movingItem.rowId !== 0 && movingItem.columnId !== 0) {
            const tempInventoryData = inventoryData;
            const level = movingItem.level === 'Top' ? 't' : 'b';
            if (tempInventoryData && movingItem.rowId && level && movingItem.columnId) {
                tempInventoryData[movingItem.rowId - 1][level][movingItem.columnId - 1] = -1;
            }
            setInventoryData(tempInventoryData);
        }

        const tempOutOfService = outOfService;
        movingItemMirror.doNotUse = true;
        setMovingItem(movingItemMirror)
        tempOutOfService.push(movingItem);
        setOutOfService(tempOutOfService);

        const tempBoxesToMove = boxesToMove;
        let exists = false;
        tempBoxesToMove?.map(boxToMove => {
            if (boxToMove.boxId === movingItem.boxId) {
                exists = true;
                boxToMove.boxId = movingItem.boxId;
                boxToMove.boxDescrip = movingItem.boxDesc ?? '';
                boxToMove.column = '';
                boxToMove.row = '';
                boxToMove.level = '';
                boxToMove.stageSheetProppantId = movingItem.stageSheetProppantId ?? '';
                boxToMove.doNotUse = true;
            }
        });

        if (!exists) {
            const tempBoxToMove: BoxesToMoveProps = {
                boxId: movingItem.boxId ?? 0,
                boxDescrip: movingItem.boxDesc ?? '',
                column: '',
                row: '',
                level: '',
                stageSheetProppantId: movingItem.stageSheetProppantId ?? '',
                doNotUse: true,
                semiAllocated: movingItem.semiAllocated,
            };
            if (!tempBoxesToMove) setBoxesToMove([tempBoxToMove]);
            else {
                tempBoxesToMove?.push(tempBoxToMove);
                setBoxesToMove(tempBoxesToMove);
            }
        }

        setMovingItem(undefined);
    };

    //Active Queue to UnAssigned Inventory
    const handleOnDropUnAssignedFromActive = ev => {
        if (!isMoveBoxes) return;

        ev.preventDefault();
        if (!movingItem || (movingItem.rowId != 0 && movingItem.columnId != 0)) return;
        if (!movingItem || movingItem.queueDesc !== 'Active') return;

        const movingItemMirror = { ...movingItem };

        // Remove from Active Queue
        const tempActiveQueue = activeQueueBoxes1?.filter(item => item.boxId !== movingItem.boxId);
        setActiveQueueBoxes1(tempActiveQueue);

        // Add to Unassigned Inventory
        const tempUnassignedInventory = [...unassignedInventory, movingItemMirror];
        setUnassignedInventory(tempUnassignedInventory);

        // Update Boxes to Move
        const tempBoxesToMove = boxesToMove || [];
        const existingBoxIndex = tempBoxesToMove.findIndex(box => box.boxId === movingItem.boxId);

        if (existingBoxIndex !== -1) {
            tempBoxesToMove[existingBoxIndex] = {
                ...tempBoxesToMove[existingBoxIndex],
                column: '',
                row: '',
                level: '',
                doNotUse: false,
                semiAllocated: true,
            };
        } else {
            tempBoxesToMove.push({
                boxId: movingItem.boxId ?? 0,
                boxDescrip: movingItem.boxDesc ?? '',
                column: '',
                row: '',
                level: '',
                stageSheetProppantId: movingItem.stageSheetProppantId ?? '',
                doNotUse: false,
                semiAllocated: true,
            });
        }
        setBoxesToMove(tempBoxesToMove);
        setMovingItem(undefined);
    };

    const handleOnSave = () => {
        moveBoxes({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    boxDetails: boxesToMove,
                },
            },
        });
    };

    const handleOnCloseAllocateModal = () => {
        setShowAllocateModal(false);
    };


    const handleOnClickOOSOption = (operation: string) => {
        setDnuOperationType(operation);
        dnuoperate({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    boxIds: dnuItems,
                    operation: operation,
                },
            },
        });
    };

    const isSpillDisabled =
        !dnuItems || dnuItems.length !== 1 || (boxesToMove ? boxesToMove.length !== 0 : false);

    const handleOnClickSpill = () => {
        if (isSpillDisabled) {
            return;
        }
        setModalError('');
        setShowSpillModal(true);
    };

    const handleOnSubmitSpill = (spillRows: SpillRowData[]) => {
        setDnuOperationType('spill');
        spillBox({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    spillModal: spillRows.map(row => ({
                        boxId: row.boxId,
                        sandTicket: row.sandTicketNumber || null,
                        loadId: row.loadId,
                        spillWeight: row.spillWeight === '' ? null : Number(row.spillWeight),
                    })),
                },
            },
        });
    };

    const selectedOOSBoxes = outOfService.filter(
        box => box.boxId != null && dnuItems?.includes(box.boxId),
    );

    const handleOnClickOOS = (ev, boxId: number) => {
        if (!dnuItems) {
            setDnuItems([boxId]);
            return;
        }

        const existingIndex = dnuItems.findIndex(item => item === boxId);
        if (existingIndex >= 0) {
            if (dnuItems.length === 1) {
                setDnuItems(undefined);
            } else {
                setDnuItems(dnuItems.filter((_, index) => index !== existingIndex));
            }
            return;
        }

        setDnuItems([...dnuItems, boxId]);
    };

    const handleOnSetUp = (rowCount, columnCount) => {
        setSetUp(true);
        configureInventory({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    rowCount: rowCount,
                    columnCount: columnCount,
                },
            },
        });
    };

    const handleOnAddColumn = () => {
        setAddColumn(true);
        configureInventory({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    rowCount: rowCount,
                    columnCount: columnCount + 1,
                },
            },
        });
    };
    document.title = jobName + '';
    const handleOnAddRow = () => {
        setAddRow(true);
        configureInventory({
            variables: {
                input: {
                    jobId: parseInt(jobIdVal),
                    rowCount: rowCount + 1,
                    columnCount: columnCount,
                },
            },
        });
    };

    const isUnsaved = (tabName: string) => {
        if (boxesToMove && boxesToMove.length > 0) {
            setShowConfirmationModal(true);
            setTabName(tabName);
        }
    };

    if (!isViewOnsiteInventory) {
        return (
            <div className="Inventory-Container">
                <ToastContainer />
                <div className="Inventory-Header-Container">
                    <div className="Inventory-Header-Text">On Site Inventory: {jobName}</div>

                    {/* For Laptop */}
                    <div className="Row Inventory-ToggleButtonsContainer">
                        <Link
                            onClick={() => isUnsaved('Jobprofile-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.JOB_PROFILE.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Jobprofile-Link"
                            className={`JobProfile-LeftToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                'JobProfile-RightToggleButton-Disabled'}`}
                        >
                            Job Details
                        </Link>
                        <Link
                            onClick={() => isUnsaved('Stagesummary-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.STAGE_SUMMARY.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Stagesummary-Link"
                            className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                'JobProfile-RightToggleButton-Disabled'}`}
                        >
                            Stage Summary
                        </Link>
                        <div className="JobProfile-CenterToggleButton JobProfile-ActiveButton">
                            <p className="JobProfile-ButtonText">Inventory</p>
                        </div>
                        <Link
                            onClick={() => isUnsaved('Joblogs-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.JOB_LOGS.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Joblogs-Link"
                            className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                'JobProfile-RightToggleButton-Disabled'}`}
                        >
                            Job Logs
                        </Link>
                        <Link
                            onClick={() => isUnsaved('JobActivity-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.JOB_ACTIVITY.route}${parseInt(jobIdVal)}`,
                            }}
                            id="JobActivity-Link"
                            className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                'JobProfile-RightToggleButton-Disabled'}`}
                        >
                            Current Activity
                        </Link>
                        <Link
                            onClick={() => isUnsaved('Driverpool-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.DRIVER_POOL.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Driverpool-Link"
                            className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                        >
                            Driver Pool
                        </Link>
                        <Link
                            onClick={() => isUnsaved('Sandallocation-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.DAILY_SAND_ALLOCATIONS.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Sandallocation-Link"
                            className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                        >
                            Sand Allocations
                        </Link>
                        <Link
                            onClick={() => isUnsaved('Jobmap-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.JOB_MAP.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Jobmap-Link"
                            className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                'JobProfile-RightToggleButton-Disabled'}`}
                        >
                            Map
                        </Link>
                        <Link
                            onClick={() => isUnsaved('Jobload-Link')}
                            to={{
                                pathname:
                                    boxesToMove && boxesToMove.length > 0
                                        ? ''
                                        : `${Routes.JOB_LOADS.route}${parseInt(jobIdVal)}`,
                            }}
                            id="Jobload-Link"
                            className={`JobProfile-RightToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                'JobProfile-RightToggleButton-Disabled'}`}
                        >
                            Loads
                        </Link>
                    </div>

                    {/* For Tab */}
                    <div className="Row Inventory-ToggleButtonsContainer-For-Tab">
                        <Dropdown className="JobProfile-CenterToggleButton-Container">
                            <Dropdown.Toggle
                                variant="link"
                                id="dropdown-basic"
                                className="JobProfile-CenterToggleButton JobProfile-CenterToggleButton-Container"
                            >
                                <span>{'Inventory'}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Jobprofile-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.JOB_PROFILE.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="Jobprofile-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobProfile-RightToggleButton-Disabled'}`}
                                    >
                                        Job Details
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Equipment-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.EQUIPMENT.route}${parseInt(jobIdVal)}`,
                                        }}
                                        className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobMenuItems-RightToggleButton-Disabled'}`}
                                    >
                                        Equipment
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Stagesummary-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.STAGE_SUMMARY.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="Stagesummary-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobProfile-RightToggleButton-Disabled'}`}
                                    >
                                        Stage Summary
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <div className="JobProfile-CenterToggleButton JobProfile-ActiveButton">
                                        <p className="JobProfile-ButtonText">Inventory</p>
                                    </div>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Joblogs-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.JOB_LOGS.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="Joblogs-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobProfile-RightToggleButton-Disabled'}`}
                                    >
                                        Job Logs
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('JobActivity-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.JOB_ACTIVITY.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="JobActivity-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobProfile-RightToggleButton-Disabled'}`}
                                    >
                                        Current Activity
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Driverpool-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.DRIVER_POOL.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="Driverpool-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                                    >
                                        Driver Pool
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Sandallocation-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.DAILY_SAND_ALLOCATIONS.route}${parseInt(
                                                        jobIdVal,
                                                    )}`,
                                        }}
                                        id="Sandallocation-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                                    >
                                        Sand Allocations
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Jobmap-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.JOB_MAP.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="Jobmap-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobProfile-RightToggleButton-Disabled'}`}
                                    >
                                        Map
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <Link
                                        onClick={() => isUnsaved('Jobload-Link')}
                                        to={{
                                            pathname:
                                                boxesToMove && boxesToMove.length > 0
                                                    ? ''
                                                    : `${Routes.JOB_LOADS.route}${parseInt(jobIdVal)}`,
                                        }}
                                        id="Jobload-Link"
                                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                            'JobProfile-RightToggleButton-Disabled'}`}
                                    >
                                        Loads
                                    </Link>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>

                <div className="NoResult-Container Inventory-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
                </div>
            </div>
        );
    }

    return (
        <div className="Inventory-Container">
            <ToastContainer />
            <div className="Inventory-Header-Container">
                <div className="Inventory-Header-Text">On Site Inventory: {jobName}</div>

                {/* For Laptop */}
                <div className="Row Inventory-ToggleButtonsContainer">
                    <Link
                        onClick={() => isUnsaved('Jobprofile-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.JOB_PROFILE.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Jobprofile-Link"
                        className={`JobProfile-LeftToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                            'JobProfile-RightToggleButton-Disabled'}`}
                    >
                        Job Details
                    </Link>
                    <Link
                        onClick={() => isUnsaved('Stagesummary-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.STAGE_SUMMARY.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Stagesummary-Link"
                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                            'JobProfile-RightToggleButton-Disabled'}`}
                    >
                        Stage Summary
                    </Link>
                    <div className="JobProfile-CenterToggleButton JobProfile-ActiveButton">
                        <p className="JobProfile-ButtonText">Inventory</p>
                    </div>
                    <Link
                        onClick={() => isUnsaved('Joblogs-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.JOB_LOGS.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Joblogs-Link"
                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                            'JobProfile-RightToggleButton-Disabled'}`}
                    >
                        Job Logs
                    </Link>
                    <Link
                        onClick={() => isUnsaved('JobActivity-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.JOB_ACTIVITY.route}${parseInt(jobIdVal)}`,
                        }}
                        id="JobActivity-Link"
                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                            'JobProfile-RightToggleButton-Disabled'}`}
                    >
                        Current Activity
                    </Link>
                    <Link
                        onClick={() => isUnsaved('Driverpool-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.DRIVER_POOL.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Driverpool-Link"
                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                    >
                        Driver Pool
                    </Link>
                    <Link
                        onClick={() => isUnsaved('Sandallocation-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.DAILY_SAND_ALLOCATIONS.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Sandallocation-Link"
                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                    >
                        Sand Allocations
                    </Link>
                    <Link
                        onClick={() => isUnsaved('Jobmap-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.JOB_MAP.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Jobmap-Link"
                        className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                            'JobProfile-RightToggleButton-Disabled'}`}
                    >
                        Map
                    </Link>
                    <Link
                        onClick={() => isUnsaved('Jobload-Link')}
                        to={{
                            pathname:
                                boxesToMove && boxesToMove.length > 0
                                    ? ''
                                    : `${Routes.JOB_LOADS.route}${parseInt(jobIdVal)}`,
                        }}
                        id="Jobload-Link"
                        className={`JobProfile-RightToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                            'JobProfile-RightToggleButton-Disabled'}`}
                    >
                        Loads
                    </Link>
                </div>

                {/* For Tab */}
                <div className="Row Inventory-ToggleButtonsContainer-For-Tab">
                    <Dropdown className="JobProfile-CenterToggleButton-Container">
                        <Dropdown.Toggle
                            variant="link"
                            id="dropdown-basic"
                            className="JobProfile-CenterToggleButton JobProfile-CenterToggleButton-Container common-tab-dropdown"
                        >
                            <span>{'Inventory'}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Jobprofile-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.JOB_PROFILE.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="Jobprofile-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobProfile-RightToggleButton-Disabled'}`}
                                >
                                    Job Details
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Equipment-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.EQUIPMENT.route}${parseInt(jobIdVal)}`,
                                    }}
                                    className={`JobMenuItems-CenterToggleButton JobMenuItems-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobMenuItems-RightToggleButton-Disabled'}`}
                                >
                                    Equipment
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Stagesummary-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.STAGE_SUMMARY.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="Stagesummary-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobProfile-RightToggleButton-Disabled'}`}
                                >
                                    Stage Summary
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <div className="JobProfile-CenterToggleButton JobProfile-ActiveButton">
                                    <p className="JobProfile-ButtonText">Inventory</p>
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Joblogs-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.JOB_LOGS.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="Joblogs-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobProfile-RightToggleButton-Disabled'}`}
                                >
                                    Job Logs
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('JobActivity-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.JOB_ACTIVITY.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="JobActivity-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobProfile-RightToggleButton-Disabled'}`}
                                >
                                    Current Activity
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Driverpool-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.DRIVER_POOL.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="Driverpool-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                                >
                                    Driver Pool
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Sandallocation-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.DAILY_SAND_ALLOCATIONS.route}${parseInt(
                                                    jobIdVal,
                                                )}`,
                                    }}
                                    id="Sandallocation-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText`}
                                >
                                    Sand Allocations
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Jobmap-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.JOB_MAP.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="Jobmap-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobProfile-RightToggleButton-Disabled'}`}
                                >
                                    Map
                                </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Link
                                    onClick={() => isUnsaved('Jobload-Link')}
                                    to={{
                                        pathname:
                                            boxesToMove && boxesToMove.length > 0
                                                ? ''
                                                : `${Routes.JOB_LOADS.route}${parseInt(jobIdVal)}`,
                                    }}
                                    id="Jobload-Link"
                                    className={`JobProfile-CenterToggleButton JobProfile-ButtonText ${!isDisplayLoadsEnabled &&
                                        'JobProfile-RightToggleButton-Disabled'}`}
                                >
                                    Loads
                                </Link>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <div className={`Inventory-Tab-Actions-Container  ${isPrinting && 'Inventory-Hidden'}`}>
                <div className="Inventory-Tab-Container">
                    <div className={`Inventory-Tab ${selectedTab === 'proppant' && 'Inventory-Tab-Selected'}`}>
                        <span
                            className="Inventory-Tab-Text"
                            onClick={(): void => {
                                setSelectedTab('proppant');
                            }}
                        >
                            Proppant
                        </span>
                    </div>

                    <div
                        className={`Inventory-Tab Inventory-Tab-With-Margin ${selectedTab === 'stage' &&
                            'Inventory-Tab-Selected'}`}
                    >
                        <span
                            className="Inventory-Tab-Text"
                            onClick={(): void => {
                                setSelectedTab('stage');
                            }}
                        >
                            Stage
                        </span>
                    </div>
                </div>

                <div className="Inventory-Sub-Header">
                    {/* For Laptop */}
                    <div className="Inventory-Button-Container">
                        <div className="Inventory-SaveButtonContainer">
                            {isMoveBoxes && boxesToMove && boxesToMove.length > 0 && (
                                <button
                                    className="Inventory-Button"
                                    onClick={handleOnSave}
                                    disabled={!(boxesToMove && boxesToMove.length > 0)}
                                >
                                    <i className="material-icons Inventory-Icon">save</i>
                                    Save
                                </button>
                            )}
                        </div>
                        {isSetupLayout && (
                            <button
                                className="Inventory-Button"
                                onClick={() => {
                                    setModalError('');
                                    setShowSetUpModal(true);
                                }}
                            >
                                <i className="material-icons Inventory-Icon Table-Icon">table_chart</i>
                                Setup
                            </button>
                        )}
                        {isSetupLayout && (
                            <button className="Inventory-Button" onClick={handleOnAddColumn}>
                                <i className="material-icons Inventory-Icon">add_circle</i>
                                Add Column
                            </button>
                        )}
                        {isSetupLayout && (
                            <button className="Inventory-Button" onClick={handleOnAddRow}>
                                <i className="material-icons Inventory-Icon">add_circle</i>
                                Add Row
                            </button>
                        )}
                        {isEditOnsiteInventory && (
                            <button
                                className="Inventory-Button"
                                onClick={() => {
                                    setModalError('');
                                    setShowEditModal(true);
                                }}
                            >
                                <i className="material-icons Inventory-Icon">edit</i>
                                Edit
                            </button>
                        )}
                        {isPrintExport && (
                            <button className="Inventory-Button" onClick={handlePrint}>
                                <i className="material-icons Inventory-Icon">print</i>
                                Print Layout
                            </button>
                        )}
                        {isPrintExport && (
                            <button className="Inventory-Button" onClick={downloadFileHandler}>
                                <i className="material-icons Inventory-Icon">get_app</i>
                                Export CSV
                                {getInventoryBoxLoading && <Loading />}
                            </button>
                        )}
                    </div>

                    {/* For Tab */}
                    <div className="Inventory-Buttons-For-Tab">
                        <div className="Inventory-SaveButtonContainer-For-Tab">
                            {isMoveBoxes && boxesToMove && boxesToMove.length > 0 && (
                                <button
                                    className="Inventory-Button"
                                    onClick={handleOnSave}
                                    disabled={!(boxesToMove && boxesToMove.length > 0)}
                                >
                                    <i className="material-icons Inventory-Icon">save</i>
                                    Save
                                </button>
                            )}
                        </div>

                        <div className="Inventory-Button-Container-For-Tab">
                            <Dropdown className="JobProfile-CenterToggleButton-Container">
                                <Dropdown.Toggle
                                    variant="link"
                                    id="dropdown-basic"
                                    className="JobProfile-CenterToggleButton JobProfile-CenterToggleButton-Container Inventory-Actions common-Actions"
                                >
                                    <span>Actions</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {isSetupLayout && (
                                        <button
                                            className="Inventory-Button-For-Tab"
                                            onClick={() => {
                                                setModalError('');
                                                setShowSetUpModal(true);
                                            }}
                                        >
                                            <i className="material-icons Inventory-Icon Table-Icon">table_chart</i>
                                            Setup
                                        </button>
                                    )}
                                    {isSetupLayout && (
                                        <button className="Inventory-Button-For-Tab" onClick={handleOnAddColumn}>
                                            <i className="material-icons Inventory-Icon">add_circle</i>
                                            Add Column
                                        </button>
                                    )}
                                    {isSetupLayout && (
                                        <button className="Inventory-Button-For-Tab" onClick={handleOnAddRow}>
                                            <i className="material-icons Inventory-Icon">add_circle</i>
                                            Add Row
                                        </button>
                                    )}
                                    {isEditOnsiteInventory && (
                                        <button
                                            className="Inventory-Button-For-Tab"
                                            onClick={() => {
                                                setModalError('');
                                                setShowEditModal(true);
                                            }}
                                        >
                                            <i className="material-icons Inventory-Icon">edit</i>
                                            Edit
                                        </button>
                                    )}
                                    {isPrintExport && (
                                        <button className="Inventory-Button-For-Tab" onClick={handlePrint}>
                                            <i className="material-icons Inventory-Icon">print</i>
                                            Print Layout
                                        </button>
                                    )}
                                    {isPrintExport && (
                                        <button className="Inventory-Button-For-Tab" onClick={downloadFileHandler}>
                                            <i className="material-icons Inventory-Icon">get_app</i>
                                            Export CSV
                                            {getInventoryBoxLoading && <Loading />}
                                        </button>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>

                    <div className="Inventory-Layout-To-print">
                        <InventoryLayout
                            innerRef={componentRef}
                            jobName={jobName}
                            inventoryData={inventoryData}
                            columnNames={columnNames}
                            proppantLegends={proppantLegends}
                        />
                    </div>
                </div>
            </div>

            {getSetUpLoading || getBoxesLoading || mutationLoading || configureMutationLoading ? (
                <div className="Inventory-Spinner-Container">
                    <Loading />
                </div>
            ) : (
                <div className={`Inventory-Table-Container ${isPrinting && 'Inventory-Table-Print'}`}>
                    {getSetupError && (
                        <div className="Inventory-Error">
                            <Error error={getSetupError} />
                        </div>
                    )}
                    {getBoxesError && (
                        <div className="Inventory-Error">
                            <Error error={getBoxesError} />
                        </div>
                    )}
                    {!getSetupError && !getBoxesError && (
                        <Table className="tables Inventory-Table" bordered>
                            <thead className="Inventory-Table-Header">
                                <tr>
                                    <th className="Inventory-Column Inventory-LeftBorder" colSpan={2}></th>
                                    {columnNames.map((columnName, index) => (
                                        <th
                                            className={`${index === columnNames.length - 1
                                                ? 'Inventory-Column Inventory-RightBorder'
                                                : 'Inventory-Column'
                                                }`}
                                            key={index}
                                        >
                                            {columnName}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {inventoryData &&
                                    inventoryData.map((inventoryDataItem, rowIndex) => (
                                        <>
                                            <tr key={`B-${rowIndex}`}>
                                                <th rowSpan={2} className="Inventory-Row">
                                                    {inventoryDataItem.rowName}
                                                </th>
                                                <td className="Inventory-BT Inventory-BottomBorder">B</td>
                                                {inventoryDataItem && inventoryDataItem.b && typeof inventoryDataItem.b !== "number" && inventoryDataItem.b.map((boxDetail, index) =>
                                                    boxDetail.boxDesc ? (
                                                        <OverlayTrigger
                                                            key={index}
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={
                                                                <div
                                                                    className="Inventory-Tooltip"
                                                                    style={{ display: movingItem ? 'none' : 'block' }}
                                                                >
                                                                    {jobProfileData?.getJobProfile?.jobDetails?.isBellyDump ?
                                                                    (<Table responsive>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>SandTicket</th>
                                                                                <th>Remaining Wt.</th>
                                                                                <th>Unallocated Wt.</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <>
                                                                        {boxDetail && boxDetail.stageSheetBellyDump?.map((load, loadIndex) => (
                                                                            <tr key={loadIndex}>
                                                                                <td>{load?.sandTicket}</td>
                                                                                <td>{load?.sandTicketWeight}</td>
                                                                                <td>{load?.sandTicketWeightRemaining}</td>
                                                                            </tr>
                                                                        ))}
                                                                        </>
                                                                        </tbody>
                                                                    </Table> ) :
                                                                    ( 
                                                                    <><div>
                                                                        Remaining Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.currentProppantWeight || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        Unallocated Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.weightRemaining || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                    </>) 
                                                                    }                                                                   
                                                                </div>
                                                            }
                                                        >
                                                            <td
                                                                className={`Inventory-Draggable Inventory-BottomBorder ${isMoveBoxes &&
                                                                    'Inventory-Draggable-Cursor'}`}
                                                                style={{
                                                                    background:
                                                                        selectedTab === 'proppant'
                                                                            ? `linear-gradient(to right, ${boxDetail.proppantColor
                                                                            } ${boxDetail.fillPerc &&
                                                                            boxDetail.fillPerc}%, 
                                                                        #f8f8f8 ${boxDetail.fillPerc &&
                                                                            boxDetail.fillPerc}%)
                                                                        `
                                                                            : `linear-gradient(to right, ${boxDetail.stageSheetColor
                                                                                ?.split(',')
                                                                                .map((stageSheetColor, index) => {
                                                                                    const color =
                                                                                        stageSheetColor === 'FFFFFF'
                                                                                            ? '#FEDB92'
                                                                                            : stageSheetColor;
                                                                                    const len =
                                                                                        boxDetail.stageSheetColor?.split(
                                                                                            ',',
                                                                                        ).length ?? 0;
                                                                                    if (index === 0)
                                                                                        return `${color} ${boxDetail.fillPerc &&
                                                                                            Math.floor(
                                                                                                boxDetail.fillPerc /
                                                                                                len,
                                                                                            )}%`;
                                                                                    else {
                                                                                        return `
                                                                                ${color} ${boxDetail.fillPerc &&
                                                                                            Math.floor(
                                                                                                (boxDetail.fillPerc /
                                                                                                    len) *
                                                                                                index +
                                                                                                1,
                                                                                            )}%,
                                                                                ${color} ${boxDetail.fillPerc &&
                                                                                            Math.floor(
                                                                                                (boxDetail.fillPerc /
                                                                                                    len) *
                                                                                                (index + 1),
                                                                                            )}%`;
                                                                                    }
                                                                                })}
                                                                        ,#f8f8f8 ${boxDetail.fillPerc &&
                                                                            boxDetail.fillPerc}%)`,
                                                                }}
                                                                draggable={isMoveBoxes}
                                                                onDragStart={event =>
                                                                    handleOnDragItem(event, boxDetail)
                                                                }
                                                            >
                                                                {boxDetail.boxDesc}
                                                            </td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td
                                                            key={index}
                                                            className="Inventory-Not-Draggable Inventory-BottomBorder"
                                                            onDrop={event =>
                                                                handleOnDropAssigned(
                                                                    event,
                                                                    rowIndex,
                                                                    inventoryDataItem.rowName,
                                                                    columnNames[index],
                                                                    index,
                                                                    'Bottom',
                                                                )
                                                            }
                                                            onDragOver={event => handleOnDragOver(event)}
                                                        >
                                                            {boxDetail.boxDesc}
                                                        </td>
                                                    ),
                                                )}
                                            </tr>
                                            <tr key={`T-${rowIndex}`}>
                                                <td className="Inventory-BT Inventory-TopBorder">T</td>
                                                {inventoryDataItem && inventoryDataItem.t && typeof inventoryDataItem.t !== "number" && inventoryDataItem.t.map((boxDetail, index) =>
                                                    boxDetail.boxDesc ? (
                                                        <OverlayTrigger
                                                            key={index}
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={
                                                                <div
                                                                    className="Inventory-Tooltip"
                                                                    style={{ display: movingItem ? 'none' : 'block' }}
                                                                >
                                                                    {jobProfileData?.getJobProfile?.jobDetails?.isBellyDump ?
                                                                    (<Table responsive>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>SandTicket</th>
                                                                                <th>Remaining Wt.</th>
                                                                                <th>Unallocated Wt.</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <>
                                                                        {boxDetail && boxDetail.stageSheetBellyDump?.map((load, loadIndex) => (
                                                                            <tr key={loadIndex}>
                                                                                <td>{load?.sandTicket}</td>
                                                                                <td>{load?.sandTicketWeight}</td>
                                                                                <td>{load?.sandTicketWeightRemaining}</td>
                                                                            </tr>
                                                                        ))}
                                                                        </>
                                                                        </tbody>
                                                                    </Table> ) :
                                                                    ( 
                                                                    <><div>
                                                                        Remaining Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.currentProppantWeight || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        Unallocated Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.weightRemaining || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                    </>) 
                                                                    }
                                                                </div>
                                                            }
                                                        >
                                                            <td
                                                                className={`Inventory-Draggable Inventory-TopBorder ${isMoveBoxes &&
                                                                    'Inventory-Draggable-Cursor'}`}
                                                                style={{
                                                                    background:
                                                                        selectedTab === 'proppant'
                                                                            ? `linear-gradient(to right, ${boxDetail.proppantColor
                                                                            } ${boxDetail.fillPerc &&
                                                                            boxDetail.fillPerc}%, 
                                                                        #f8f8f8 ${boxDetail.fillPerc &&
                                                                            boxDetail.fillPerc}%)
                                                                        `
                                                                            : `linear-gradient(to right, ${boxDetail.stageSheetColor
                                                                                ?.split(',')
                                                                                .map((stageSheetColor, index) => {
                                                                                    const color =
                                                                                        stageSheetColor === 'FFFFFF'
                                                                                            ? '#FEDB92'
                                                                                            : stageSheetColor;
                                                                                    const len =
                                                                                        boxDetail.stageSheetColor?.split(
                                                                                            ',',
                                                                                        ).length ?? 0;
                                                                                    if (index === 0)
                                                                                        return `${color} ${boxDetail.fillPerc &&
                                                                                            Math.floor(
                                                                                                boxDetail.fillPerc /
                                                                                                len,
                                                                                            )}%`;
                                                                                    else {
                                                                                        return `
                                                                                ${color} ${boxDetail.fillPerc &&
                                                                                            Math.floor(
                                                                                                (boxDetail.fillPerc /
                                                                                                    len) *
                                                                                                index +
                                                                                                1,
                                                                                            )}%,
                                                                                ${color} ${boxDetail.fillPerc &&
                                                                                            Math.floor(
                                                                                                (boxDetail.fillPerc /
                                                                                                    len) *
                                                                                                (index + 1),
                                                                                            )}%`;
                                                                                    }
                                                                                })} ,#f8f8f8 ${boxDetail.fillPerc &&
                                                                                boxDetail.fillPerc}%)`,
                                                                }}
                                                                draggable={isMoveBoxes}
                                                                onDragStart={event =>
                                                                    handleOnDragItem(event, boxDetail)
                                                                }
                                                            >
                                                                {boxDetail.boxDesc}
                                                            </td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td
                                                            key={index}
                                                            className="Inventory-Not-Draggable Inventory-TopBorder"
                                                            onDrop={event =>
                                                                handleOnDropAssigned(
                                                                    event,
                                                                    rowIndex,
                                                                    inventoryDataItem.rowName,
                                                                    columnNames[index],
                                                                    index,
                                                                    'Top',
                                                                )
                                                            }
                                                            onDragOver={event => handleOnDragOver(event)}
                                                        >
                                                            {boxDetail.boxDesc}
                                                        </td>
                                                    ),
                                                )}
                                            </tr>
                                        </>
                                    ))}
                            </tbody>
                        </Table>
                    )}
                </div>
            )}

            <div className="Inventory-Legends-Container">
                <div className="Inventory-Legends">
                    {selectedTab === 'proppant'
                        ? proppantLegends.map((proppantLegend, index) => (
                            <div className="Inventory-Legend" key={index}>
                                <div
                                    className="Inventory-Legend-Color"
                                    style={{ backgroundColor: proppantLegend.color }}
                                ></div>
                                <div className="Inventory-Legend-Title">{proppantLegend.title}</div>
                            </div>
                        ))
                        : stageLegends.map((stageLegend, index) => (
                            <div className="Inventory-Legend" key={index}>
                                <div
                                    className="Inventory-Legend-Color"
                                    style={{ backgroundColor: stageLegend.color }}
                                ></div>
                                <div className="Inventory-Legend-Title">{stageLegend.title}</div>
                            </div>
                        ))}
                </div>
                <div className="Inventory-Legends">
                    {assginedCount.map((assigned, index) => (
                        <div className="Inventory-Legend" key={index}>
                            <div className="Inventory-Legend-Title2">
                                <b>{assigned.name}:</b> {assigned.weight} lbs ({assigned.count})
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Table className="tables" bordered hover>
                <thead>
                    <tr>
                        <th rowSpan={4} colSpan={5} className="Inventory-Forklift-Section">
                            <i className="material-icons Inventory-ForkLift-Icon">arrow_upward</i>
                            Forklift
                        </th>
                    </tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                </thead>
            </Table>

            <div className={`Inventory-TableCollection ${isPrinting && 'Inventory-Hidden'}`}>
                <Table className="tables Inventory-TableCollection-Table" hover bordered>
                    <thead>
                        <tr className="Inventory-TableCollection-Header">
                            <th>Empty Box Inventory ({emptyCount})</th>
                        </tr>
                    </thead>
                    {getSetUpLoading || getBoxesLoading || mutationLoading || configureMutationLoading ? (
                        <div className="Inventory-Spinner-Container">
                            <Loading />
                        </div>
                    ) : (
                        <tbody className="Inventory-Table-Boxes">
                            {emptyBoxes &&
                                emptyBoxes.map((emptyBox, index) => (
                                    <tr className="Inventory-Table-Boxes-Item" key={index}>
                                        <td>{emptyBox}</td>
                                    </tr>
                                ))}
                        </tbody>
                    )}
                </Table>

                <Table className="tables Inventory-TableCollection-Table" hover bordered>
                    <thead className="Inventory-TableCollection-Header">
                        <tr>
                            <th>Out of Service ({OOSCount})</th>
                        </tr>
                    </thead>
                    {getSetUpLoading ||
                        getBoxesLoading ||
                        mutationLoading ||
                        dnuMutationLoading ||
                        configureMutationLoading ? (
                        <div className="Inventory-Spinner-Container">
                            <Loading />
                        </div>
                    ) : (
                        <tbody
                            className="Inventory-Table-Boxes"
                            onDrop={event => handleOnDropOutOfService(event)}
                            onDragOver={event => handleOnDragOver(event)}
                        >
                            {outOfService.map((item, index) => (
                                <OverlayTrigger
                                    key={item.boxId ?? index}
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                        <div className="Inventory-Tooltip">
                                            <div>
                                                Remaining Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.currentProppantWeight ?? 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                            <div>
                                                Unallocated Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.weightRemaining || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                        </div>
                                    }
                                >
                                    <tr className="Inventory-Table-Boxes-Item" key={item.boxId ?? index}>
                                        <td
                                            style={{
                                                background: `linear-gradient(to right, ${item.proppantColor} ${item.fillPerc}%, #f8f8f8 ${item.fillPerc}%)`,
                                            }}
                                        >
                                            {isMoveBoxes && (boxesToMove ? boxesToMove?.length === 0 : true) && (
                                                <input
                                                    type="radio"
                                                    className="OutOfService-Radio-Button"
                                                    checked={!!(item.boxId && dnuItems?.includes(item.boxId))}
                                                    onClick={ev => item.boxId && handleOnClickOOS(ev, item.boxId)}
                                                    readOnly
                                                />
                                            )}
                                            {item.boxDesc}
                                        </td>
                                    </tr>
                                </OverlayTrigger>
                            ))}
                        </tbody>
                    )}

                    {isMoveBoxes && (
                        <tfoot className="OutOfService-Footer">
                            <button
                                className={`OutOfService-Button ${!dnuItems ||
                                    dnuItems?.length < 0 ||
                                    (boxesToMove ? boxesToMove?.length !== 0 : false)
                                    ? 'Inventory-Button-Disabled'
                                    : ''
                                    }`}
                                onClick={() => handleOnClickOOSOption('inservice')}
                                disabled={!dnuItems || (boxesToMove ? boxesToMove?.length !== 0 : false)}
                            >
                                Inservice
                            </button>
                            <button
                                className={`OutOfService-Button OutOfService-Delete-Button ${!dnuItems ||
                                    dnuItems?.length < 0 ||
                                    (boxesToMove ? boxesToMove?.length !== 0 : false)
                                    ? 'Inventory-Button-Disabled'
                                    : ''
                                    }`}
                                onClick={() => handleOnClickOOSOption('remove')}
                                disabled={!dnuItems || (boxesToMove ? boxesToMove?.length !== 0 : false)}
                            >
                                Picked Up
                            </button>
                            <button
                                className={`OutOfService-Button OutOfService-Delete-Button ${
                                    isSpillDisabled ? 'Inventory-Button-Disabled' : ''
                                }`}
                                onClick={handleOnClickSpill}
                                disabled={isSpillDisabled}
                            >
                                Spill
                            </button>
                        </tfoot>
                    )}
                </Table>
                { jobProfileData?.getJobProfile?.jobDetails?.isBellyDump &&
                    <Table className="tables Inventory-TableCollection-Table" hover bordered>
                        <thead className="Inventory-TableCollection-Header">
                            <tr>
                                <th>Active Queue ({activeQueueBoxes1?.length})</th>
                            </tr>
                        </thead>
                        {getActiveQueueLoading? (
                            <div className="Inventory-Spinner-Container">
                                <Loading />
                            </div>
                        ) : (
                            <tbody
                                className="Inventory-Table-Boxes"
                                onDrop={event => handleOnDropUnassigned(event)}
                                onDragOver={event => handleOnDragOver(event)}
                            >
                            {getSetUpLoading ||
                                getBoxesLoading ||
                                mutationLoading || 
                                activeQueueBoxes1?.map((item, index) => (
                                    <OverlayTrigger
                                        key={index}
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                            <div className="Inventory-Tooltip">
                                                {/* <div>
                                                    Remaining Weight: &nbsp;
                                                    <NumberFormat
                                                        value={44000- (item.currentProppantWeight ?? 0)}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                    />
                                                </div> */}
                                                <div>
                                                    Allocated Weight: &nbsp;
                                                    <NumberFormat
                                                        value={item.currentProppantWeight || 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    >
                                        <tr
                                            className={`Inventory-Table-Boxes-Item ${isMoveBoxes &&
                                                'Inventory-Unassigned-Draggable'}`}
                                            key={index}
                                        >
                                            <td
                                                style={{
                                                    background: `linear-gradient(to right, ${item.proppantColor}  ${item.fillPerc}%, #f8f8f8 ${item.fillPerc}%)`,
                                                }}
                                                draggable={isMoveBoxes}
                                                onDragStart={event => handleOnDragItem(event, item)}
                                            >
                                                {item.boxDesc}                                              
                                            </td>
                                            
                                        </tr>
                                    </OverlayTrigger>
                                ))}
                        </tbody>
                        )};
                        
                    </Table>
                }
                
                { jobProfileData?.getJobProfile?.jobDetails?.isBellyDump &&
                    <Table className="tables Inventory-TableCollection-Table" hover bordered>
                        <thead className="Inventory-TableCollection-Header">
                            <tr>
                                <th>Allocation Inventory ({allocationInventory.length})</th>
                            </tr>
                        </thead>
                        {getAllocationInvLoading? (
                            <div className="Inventory-Spinner-Container">
                                <Loading />
                            </div>
                        ) : (
                            <tbody
                                className="Inventory-Table-Boxes"
                                onDrop={event => handleOnDropUnassigned(event)}
                                onDragOver={event => handleOnDragOver(event)}
                            >
                            {allocationInventory.map((item, index) => (
                                    <OverlayTrigger
                                        key={index}
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                            <div className="Inventory-Tooltip">
                                                <div>
                                                    Remaining Weight: &nbsp;
                                                    <NumberFormat
                                                        value={item.weightRemaining ?? 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                    />
                                                </div>
                                                <div>
                                                    Delivered Weight: &nbsp;
                                                    <NumberFormat
                                                        value={item.weightDelivered || 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    >
                                        <tr
                                            className={`Inventory-Table-Boxes-Item ${isMoveBoxes &&
                                                'Inventory-Unassigned-Draggable'}`}
                                            key={index}
                                        >
                                            <td
                                                style={{
                                                    background: `linear-gradient(to right, ${item.proppantColor}  ${item.fillPerc}%, #f8f8f8 ${item.fillPerc}%)`,
                                                }}
                                                draggable={false}
                                                //onDragStart={event => handleOnDragItem(event, item)}
                                            >
                                                {item.loadId}
                                                {(item.isLoadAllocated || isAllocateAllLoads) && (
                                                    <>
                                                        <a 
                                                            style={{ float: 'right' }}                                             
                                                            onClick={() => {
                                                                setLoadId(item.loadId);
                                                                setProppantId(item.proppantId);
                                                                setBoxDesc(item.boxDesc);
                                                                setProppantDesc(item.proppantDesc);
                                                                setBoxWeight(item.weightDelivered);
                                                                setShowAllocateModal(true);
                                                            }} 
                                                            href="#" 
                                                        >
                                                            Allocate
                                                        </a>
                                                    </>
                                                )}
                                            </td>
                                            
                                        </tr>
                                    </OverlayTrigger>
                                ))}
                        </tbody>
                        )}
                    </Table>
                }
                
                <Table className="tables Inventory-TableCollection-Table" hover bordered>
                    <thead className="Inventory-TableCollection-Header">
                        <tr>
                            <th>Unassigned Inventory ({unassignedCount})
                                {jobProfileData?.getJobProfile?.jobDetails?.isBellyDump &&
                                <>
                                    <i onClick={() => handleOnClickRevert()} className="material-icons Inventory-Revert-Icon">replay</i>
                                    <span onClick={() => handleOnClickRevert()} className='Inventory-Revert-Header'>Revert</span></>
                                }
                            </th>
                        </tr>
                    </thead>
                    {getSetUpLoading ||
                        getBoxesLoading ||
                        mutationLoading ||
                        (dnuMutationLoading && (dnuOperationType === 'inservice' || dnuOperationType === 'remove')) ||
                        spillMutationLoading ? (
                        <div className="Inventory-Spinner-Container">
                            <Loading />
                        </div>
                    ) : (
                        <tbody
                            className="Inventory-Table-Boxes"
                            onDrop={event => {handleOnDropUnassigned(event); handleOnDropUnAssignedFromActive(event)}}
                            onDragOver={event => handleOnDragOver(event)}
                        >
                            {unassignedInventory.map((item, index) => (
                                <OverlayTrigger
                                    key={index}
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                        <div
                                            className="Inventory-Tooltip"
                                            style={{ display: movingItem ? 'none' : 'block' }}
                                        >
                                            {jobProfileData?.getJobProfile?.jobDetails?.isBellyDump ?
                                            (<Table responsive>
                                                <thead>
                                                    <tr>
                                                        <th>Load</th>
                                                        <th>SandTicket</th>
                                                        <th>Remaining Wt.</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                <>
                                                {item && item.stageSheetBellyDump?.map((load, loadIndex) => (
                                                    <tr key={loadIndex}>
                                                        <td>{load?.loadId}</td>
                                                        <td>{load?.sandTicket}</td>
                                                        <td>{load?.sandTicketWeight}</td>
                                                    </tr>
                                                ))}
                                                </>
                                                </tbody>
                                            </Table> ) :
                                            ( 
                                            <><div>
                                                Remaining Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.currentProppantWeight || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                            </>) 
                                            }
                                        </div>
                                    }
                                >
                                    <tr
                                        className={`Inventory-Table-Boxes-Item ${isMoveBoxes &&
                                            'Inventory-Unassigned-Draggable'}`}
                                        key={index}
                                    >
                                        <td
                                            style={{
                                                background: `linear-gradient(to right, ${item.proppantColor} ${item.fillPerc}%, #f8f8f8 ${item.fillPerc}%)`,
                                            }}
                                            draggable={isMoveBoxes}
                                            onDragStart={event => handleOnDragItem(event, item)}
                                        >
                                            {item.boxDesc}
                                        </td>
                                    </tr>
                                </OverlayTrigger>
                            ))}
                        </tbody>
                    )}
                </Table>
            </div>

            {showSetUpModal && (
                <SetUpModal
                    showSetUpModal={showSetUpModal}
                    setShowSetUpModal={setShowSetUpModal}
                    row={rowCount}
                    column={columnCount}
                    mutationLoading={configureMutationLoading}
                    setModalError={setModalError}
                    modalError={modalError}
                    handleOnSetUp={(rowCount, columnCount) => handleOnSetUp(rowCount, columnCount)}
                />
            )}

            {showEditModal && jobProfileData?.getJobProfile?.jobDetails && (
                <EditBoxesModal
                    setShowModal={setShowEditModal}
                    showModal={showEditModal}
                    mutationLoading={editLoading}
                    setModalError={setModalError}
                    modalError={modalError}
                    handleOnSave={handleOnEdit}
                    jobData={jobProfileData.getJobProfile.jobDetails}
                />
            )}

            {showRevertModal && jobProfileData?.getJobProfile?.jobDetails && (
                <RevertBoxesModal
                    setShowModal={setShowRevertModal}
                    showModal={showRevertModal}
                    mutationLoading={revertMutationLoading}
                    setModalError={setModalError}
                    modalError={modalError}
                    handleOnRevert={handleOnRevert}
                    jobData={jobProfileData.getJobProfile.jobDetails}
                />
            )}

            {showSpillModal && (
                <SpillModal
                    showModal={showSpillModal}
                    setShowModal={setShowSpillModal}
                    selectedBoxes={selectedOOSBoxes}
                    mutationLoading={spillMutationLoading}
                    modalError={modalError}
                    setModalError={setModalError}
                    onSubmit={handleOnSubmitSpill}
                />
            )}

            
            {showAllocateModal && (
            <AllocateLoadUI
                loadId = {loadId? loadId: null}
                jobId={parseInt(jobIdVal)}
                proppantId = {proppantId? proppantId: null}
                proppantDesc = {proppantDesc?proppantDesc:''}
                boxDesc = {boxDesc?boxDesc:''}
                weightDelivered = {boxWeight?boxWeight:null}
                showStageSheetPartialModal={showAllocateModal}
                handleOnClose={handleOnCloseAllocateModal}
                refetch={refetch}
                modalError={modalError}
                setModalError={setModalError}
            />
            )}

            <UnSavedConfirmationModal
                showModal={showConfirmationModal}
                setShowModal={setShowConfirmationModal}
                tabName={tabName}
                jobId={parseInt(jobIdVal)}
            />
        </div>
    );
};

export default Inventory;
